<template>
  <Dialog position="center" :visible.sync="showModalSocialMediaData" @hide="closeDialog">
    <ModalLoading :show="showModalLoading" :text="textModalLoading" @close="closeModal" />
    <TabView>
      <TabPanel v-if="instagramSelected" header="Instagram">
        <h2 style="margin-bottom: 20px">
          Total de itens: <strong>{{ localDataInstagram.length }}</strong>
        </h2>
        <h3 v-if="!!!localDataInstagram">Nenhuma hashtag encontrada</h3>
        <div class="dialog-social-media-container">
          <div
            v-for="socialMediaData in localDataInstagram"
            :key="socialMediaData.id + (socialMediaData.media_url || '')"
            class="dialog-social-media-card"
          >
            <div class="media-container">
              <img
                :src="socialMediaData.media_url"
                alt="imagem da hashtag"
                v-if="socialMediaData.media_type !== 'VIDEO'"
                @click="handleRedirectToInstagram(socialMediaData.permalink)"
              />
              <video controls v-if="socialMediaData.media_type === 'VIDEO'">
                <source :src="socialMediaData.media_url" type="video/mp4" />
              </video>
            </div>
            <div class="content-container">
              <p class="dialog-social-media-text">{{ socialMediaData.caption }}</p>
              <div class="stats-container">
                <span class="stat-item">
                  <i class="fa-solid fa-clock"></i>
                  {{ convertTimestamp(socialMediaData.timestamp) }}
                </span>
                <span class="stat-item">
                  <i class="fa-solid fa-comments"></i>
                  {{ socialMediaData.comments_count }}
                </span>
                <span class="stat-item">
                  <i class="fa-solid fa-heart"></i>
                  {{ socialMediaData.like_count }}
                </span>
              </div>
              <!--<button
                @click="handleDeleteInstagramPost(socialMediaData.id)"
                class="delete-btn"
                title="Excluir post"
              >
                <i class="fa-solid fa-trash"></i>
              </button> -->
          </div>
          </div>
        </div>
      </TabPanel>
      <TabPanel v-if="tiktokSelected" header="Tiktok">
        <div v-if="!tiktokData.length">
          <ProgressSpinner
            v-if="tiktokData.status === 'running'"
            style="width: 40px; height: 40px"
          />
          </div>
        <div v-if="!tiktokData.length && tiktokData.status !== 'running'">
          <h2 style="margin-bottom: 20px">
            Total de itens: <strong>{{ tiktokData.length }}</strong>
          </h2>
        </div>
        <div v-if="tiktokData.length">
          <h2 style="margin-bottom: 20px">
            Total de itens: <strong>{{ tiktokData.length }}</strong>
          </h2>
          <div class="dialog-social-media-container">
            <div v-for="data in tiktokData" :key="tiktokData.id" class="dialog-social-media-card">
              <div class="media-container">
                <img
                  :src="data.preview_image"
                  alt="imagem da hashtag"
                  @click="handleRedirectToInstagram(data.url)"
                />
              </div>
              <div class="content-container">
                <p class="dialog-social-media-text">{{ data.description }}</p>
                <div class="stats-container">
                  <span class="stat-item">
                    <i class="fa-solid fa-clock"></i>
                    {{ convertTimestamp(data.create_time) }}
                  </span>
                  <span class="stat-item">
                    <i class="fa-solid fa-comments"></i>
                    {{ data.comment_count }}
                  </span>
                  <span class="stat-item">
                    <i class="fa-solid fa-heart"></i>
                    {{ data.digg_count }}
                  </span>
                </div>
                <button
                  @click="handleDeleteTiktokPost(data.post_id)"
                  class="delete-btn"
                  title="Excluir post"
                >
                  <i class="fa-solid fa-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </TabPanel>

      <TabPanel header="Pontos turísticos">
        <h2 style="margin-bottom: 20px" v-if="!!touristAttractionData">
          Total de itens: <strong>{{ touristAttractionData.length }}</strong>
        </h2>
        <h3 v-if="!!!touristAttractionData">Nenhum atração turistica encontrada</h3>

        <div v-if="!!touristAttractionData" style="margin-bottom: 20px; margin-top: 10px">
          <input
            type="checkbox"
            v-model="selectAllAttractions"
            @change="selectAllAttractionsItems"
            style="margin-right: 10px"
          />
          <label for="selectAllAttractions">Selecionar todos os itens</label>
        </div>
        <div class="dialog-social-media-container">
          <div
            v-for="touristAttraction in touristAttractionData"
            :key="touristAttraction.name"
            class="dialog-social-media-card tourist-attraction"
          >
            <div class="content-container">
              <div class="checkbox-container">
                <input
                  type="checkbox"
                  :id="'checkbox_' + touristAttraction.place_id"
                  v-model="touristAttraction.selected"
                />
                <label :for="'checkbox_' + touristAttraction.place_id">Selecionar</label>
              </div>
              <h3 class="attraction-name">{{ touristAttraction.name }}</h3>
              <div class="stats-container">
                <span class="stat-item">
                  <i class="fa-solid fa-star"></i>
                  Avaliação: <strong>{{ touristAttraction.rating }}</strong>
                </span>
                <span class="stat-item">
                  <i class="fa-solid fa-comments"></i>
                  Menções: <strong>{{ touristAttraction.review_count }}</strong>
                </span>
              </div>
                    </div>
                  </div>
                    </div>
      </TabPanel>

      <TabPanel header="Top influencers">
        <div v-if="showInfluencersCards">
          <h2 style="margin-bottom: 20px">
            Total de itens: <strong>{{ influencersData.length }}</strong>
          </h2>
                    </div>
        <div v-if="showInfluencersCards" style="margin-bottom: 20px; margin-top: 10px">
          <input
            type="checkbox"
            v-model="selectAll"
            @change="selectAllItems"
            style="margin-right: 10px"
          />
          <label for="selectAll">Selecionar todos os itens</label>
                  </div>
        <div v-if="showInfluencersCards">
          <div class="dialog-social-media-container">
            <div
              v-for="influencer in influencersData"
              :key="influencer.id"
              class="dialog-social-media-card-influencer"
            >
              <div class="checkbox-container">
                <input
                  type="checkbox"
                  :id="'checkbox_' + influencer.id"
                  v-model="influencer.selected"
                />
                <label :for="'checkbox_' + influencer.id">Selecionar</label>
                </div>
              <h3 
                class="influencer-name"
                @click="handleOpenInstagramLink(influencer.name)"
              >
                {{ influencer.name }}
              </h3>
              <div class="stats-container">
                <span class="stat-item">
                  <i class="fa-solid fa-users"></i>
                  {{ influencer.followers_count }}
                </span>
                <span class="stat-item">
                  <i class="fa-solid fa-photo-film"></i>
                  {{ influencer.media_count }}
                </span>
              </div>
            </div>
          </div>
          <loading-button :loading="isLoadingGetInfluencers" class="btn-indigo" @click="retry">
            Buscar Novamente
          </loading-button>
          <div class="button-container">
            <button @click="closeDialog" class="cancel">Cancelar</button>
            <button @click="selectItemsAndClose" v-if="isUpdate">Atualizar Filtro</button>
            <button @click="selectItemsAndClose" v-if="!isUpdate">Criar Filtro</button>
          </div>
        </div>
        <div v-if="!showInfluencersCards">
          <div v-for="(input, index) in influencerInputs" :key="input.id" class="input-container">
            <input
              v-model="input.value"
              type="text"
              class="pr-6 pb-8 w-full lg:w-full"
              placeholder="Digite o nome do influenciador"
              @keydown.enter="addNewInput"
            />
            <button
              v-if="influencerInputs.length > 1"
              @click="removeInput(index)"
              class="remove-btn"
            >
              &times;
            </button>
      </div>
          <loading-button
            :loading="isLoadingGetInfluencers"
            class="btn-indigo"
            @click="getInfluencersManual"
          >
            Buscar influencers na API
          </loading-button>
    </div>
      </TabPanel>
    </TabView>
    <Toast position="top-center" />
  </Dialog>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import Dialog from 'primevue/dialog'
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'
import Badge from 'primevue/badge'
import Toast from 'primevue/toast'
import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'
import ProgressSpinner from 'primevue/progressspinner'
import { mapState } from 'pinia'
import { useSocialMedia } from '@/stores/socialMedia'
import LoadingButton from '@/Shared/LoadingButton'
import Button from '@/Shared/Button'
import TextareaInput from '@/Shared/TextareaInput'
import ModalLoading from './ModalLoading.vue'
moment.locale('pt-br')

export default {
  components: {
    Dialog,
    TabPanel,
    TabView,
    Badge,
    LoadingButton,
    TextareaInput,
    Button,
    Accordion,
    AccordionTab,
    Toast,
    ModalLoading,
    ProgressSpinner,
  },
  props: {
    isUpdate: Boolean,
    term: String,
    showModalSocialMediaData: Boolean,
    dataInstagram: Array,
    touristAttractionData: Array,
    influencers: Array,
    upsertFilter: Function,
    mediaPagination: String,
    cityId: Number,
    stateId: Number,
    snapshotId: String,
    instagramSelected: Boolean,
    tiktokSelected: Boolean,
    tiktokKeywords: Array,
  },
  data() {
    return {
      selectAll: false,
      selectAllAttractions: false,
      selectAllHashtags: false,
      isLoadingGetInfluencers: false,
      showInfluencersCards: false,
      influencersData: this.influencers,
      query: '',
      manualQuery: '',
      influencerInputs: [{ id: Date.now(), value: '' }],
      hasReachedEnd: false,
      localDataInstagram: [],
      tiktokData: [],
      showModalLoading: false,
      textModalLoading: 'Carregando posts...',
      pollingInterval: null,
      isPolling: false,
      isFirstRender: true,
      activeTabIndex: 0,
    }
  },
  mounted() {
    this.startPolling()
    this.localDataInstagram = [...this.dataInstagram]

    this.$nextTick(() => {
      // Configurar listener para mudança de abas
      const tabPanels = this.$el.querySelectorAll('.p-tabview-nav li')
      tabPanels.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          this.activeTabIndex = index
          this.updateScrollListener()
        })
      })

      // Configurar o listener de scroll inicial
      this.updateScrollListener()
    })
  },

  beforeDestroy() {
    const scrollContainer = this.$el.querySelector('.p-dialog-content')
    if (scrollContainer) {
      scrollContainer.removeEventListener('scroll', this.handleScroll)
    }

    // Remova também os listeners de clique nas abas
    const tabPanels = this.$el.querySelectorAll('.p-tabview-nav li')
    tabPanels.forEach((tab, index) => {
      tab.removeEventListener('click', () => {
        this.activeTabIndex = index
        this.updateScrollListener()
      })
    })

    this.stopPolling()
  },
  methods: {
    addNewInput() {
      this.influencerInputs.push({ id: Date.now(), value: '' })
    },
    removeInput(index) {
      this.influencerInputs.splice(index, 1)
    },
    convertTimestamp(date) {
      return moment(date).format('DD/MM/YYYY HH:MM')
    },
    handleRedirectToInstagram(permalink) {
      window.open(permalink)
    },
    selectAllItems() {
      this.influencersData.forEach((item) => {
        item.selected = this.selectAll
      })
    },
    selectAllAttractionsItems() {
      this.touristAttractionData.forEach((item) => {
        item.selected = this.selectAllAttractions
      })
    },
    handleOpenInstagramLink(influencer) {
      window.open(`https://instagram.com/${influencer.trim().replace(' ', '')}`)
    },
    retry() {
      this.showInfluencersCards = false
      this.influencersData = []
    },
    async getInfluencers() {
      try {
        this.isLoadingGetInfluencers = true
        const response = await axios.post(`/api/social-media/influencers`, {
          query: this.query,
        })
        this.influencersData = response.data
        this.showInfluencersCards = true
      } catch (error) {
        this.isLoadingGetInfluencers = false
      } finally {
        this.isLoadingGetInfluencers = false
      }
    },
    async getInfluencersManual() {
      const filteredInputs = this.influencerInputs
        .map((input) => input.value.trim())
        .filter((value) => value !== '')

      const influencersString = filteredInputs.join(';')

      try {
        this.isLoadingGetInfluencers = true
        const response = await axios.post(`/api/social-media/influencers/manual`, {
          query: influencersString,
        })
        this.influencersData = response.data
        this.showInfluencersCards = true
      } catch (error) {
        this.isLoadingGetInfluencers = false
      } finally {
        this.isLoadingGetInfluencers = false
      }
    },

    closeDialog() {
      this.$emit('update:showModalSocialMediaData', false)
      this.stopPolling()
    },
    selectItemsAndClose() {
      const influencer = this.influencersData.filter((item) => item.selected)
      const tourist = this.touristAttractionData.filter((item) => item.selected)
      this.touristAttractionData.map((item) => (item.term = this.term))
      if (!influencer.length) {
        this.$toast.add({
          severity: 'info',
          summary: 'Selecione os influencers!',
          life: 3000,
        })
        return false
      }
      if (!tourist.length) {
        this.$toast.add({
          severity: 'info',
          summary: 'Selecione as pontos turísticos!',
          life: 3000,
        })
        return false
      }
      this.getTopInfluencers(influencer)
      this.getTouristAttractions(tourist)
      this.showModalSocialMediaData = false
      this.upsertFilter()
    },

    async loadMoreMedias() {
      if (this.isLoadingMore || !this.localDataInstagram.length || this.tiktokSelected) return

      try {
        this.isLoadingMore = true
        this.showModalLoading = true
        this.textModalLoading = 'Carregando posts...'

        const response = await axios.post('/api/social-media/search/upsert/medias', {
          value: this.term,
          after: this.mediaPagination,
          city_id: this.cityId,
          state_id: this.stateId,
        })
        const newMedias = response.data.medias || []

        this.localDataInstagram = [...this.localDataInstagram, ...newMedias]
        this.$emit('update:modalSocialMediaData', this.localDataInstagram)

        this.hasMorePages = Boolean(this.mediaPagination)
      } catch (error) {
        console.error('Erro ao carregar mais postagens:', error)
        this.isLoadingMore = false
        this.showModalLoading = false
      } finally {
        this.isLoadingMore = false
        this.showModalLoading = false
      }
    },

    updateScrollListener() {
      const scrollContainer = this.$el.querySelector('.p-dialog-content')

      // Sempre remova o listener antigo primeiro
      if (scrollContainer) {
        scrollContainer.removeEventListener('scroll', this.handleScroll)
      }

      // Adicione o listener apenas se a aba ativa for Instagram (índice 0)
      if (this.activeTabIndex === 0) {
        scrollContainer.addEventListener('scroll', this.handleScroll)
      }
    },

    // Simplifique o handleScroll
    handleScroll(event) {
      const container = event.target
      if (!container && this.tiktokSelected) return

      const scrollTop = container.scrollTop
      const scrollHeight = container.scrollHeight
      const clientHeight = container.clientHeight

      const isAtEnd = scrollHeight - scrollTop - clientHeight < 20

      if (isAtEnd && !this.hasReachedEnd && !this.isFirstRender && !this.isLoadingMore) {
        this.loadMoreMedias()
        this.hasReachedEnd = true
      } else if (!isAtEnd) {
        this.hasReachedEnd = false
      }

      this.isFirstRender = false
    },

    closeModal() {
      this.showModalLoading = false
    },
    startPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval)
      }

      this.isPolling = true
      this.getCollectedData()

      this.pollingInterval = setInterval(() => {
        this.getCollectedData()
        // }, 120000)
      }, 15000) //15 segundos
    },

    stopPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval)
        this.pollingInterval = null
        this.isPolling = false
      }
    },

    async getCollectedData() {
      try {
        const response = await axios.post(`/api/bright-data/tiktok/data`, {
          keywords: this.tiktokKeywords,
          snapshotId: this.snapshotId,
        })
        this.tiktokData = response.data

        if (response.data === null) {
          this.stopPolling()
        } else if (Array.isArray(response.data) && response.data.length > 0) {
          this.stopPolling()
        }
      } catch (error) {
        console.error('Erro ao buscar dados:', error)
        this.stopPolling()
      }
    },
    async handleDeleteTiktokPost(postId) {
      try {
        // Mostra uma confirmação antes de excluir
        if (!confirm('Tem certeza que deseja excluir este post?')) {
          return
        }

        this.showModalLoading = true
        this.textModalLoading = 'Deletando post...'

        // Faz a requisição para o backend Laravel
        await axios.delete(`/api/bright-data/tiktok/${postId}`)

        // Remove o post da lista local após exclusão bem-sucedida
        this.tiktokData = this.tiktokData.filter((post) => post.post_id !== postId)

        // Notifica o usuário
        this.$toast.add({
          severity: 'success',
          summary: 'Post excluído com sucesso!',
          life: 3000,
        })
      } catch (error) {
        console.error('Erro ao excluir post:', error)
        this.$toast.add({
          severity: 'error',
          summary: 'Erro ao excluir post',
          detail: 'Ocorreu um erro ao tentar excluir o post. Por favor, tente novamente.',
          life: 5000,
        })
      } finally {
        this.showModalLoading = false
      }
    },
    async handleDeleteInstagramPost(mediaId) {
      try {
        const response = await axios.post('/api/facebook/delete-instagram-post', {
          media_id: mediaId
        });

        if (response.data.success) {
          // Remove o post da lista local
          this.localDataInstagram = this.localDataInstagram.filter(
            post => post.id !== mediaId
          );

          // Mostra mensagem de sucesso
          this.$toast.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Post excluído com sucesso',
            life: 3000
          });
        } else {
          throw new Error(response.data.message);
        }
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Erro',
          detail: error.message || 'Erro ao excluir post',
          life: 3000
        });
      }
    },
  },
  watch: {
    dataInstagram: {
      handler(newData) {
        this.localDataInstagram = [...newData]
        this.hasReachedEnd = false
        this.isFirstRender = true
        this.$nextTick(() => {
          this.updateScrollListener()
        })
      },
      immediate: true,
    },
    influencers: {
      handler(data) {
        if (data?.length) {
          this.showInfluencersCards = true
          this.influencersData = data
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState(useSocialMedia, ['getTopInfluencers']),
    ...mapState(useSocialMedia, ['getTouristAttractions']),
  },
}
</script>

<style scoped>
.dialog-social-media-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  padding: 20px;
  width: 100%;
  margin-bottom: 20px;
}

.dialog-social-media-card {
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  height: 500px;
}

.dialog-social-media-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
}

.dialog-social-media-card .media-container {
  position: relative;
  width: 100%;
  height: 300px;
  overflow: hidden;
  border-radius: 16px 16px 0 0;
}

.dialog-social-media-card .media-container img,
.dialog-social-media-card .media-container video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.dialog-social-media-card:hover .media-container img {
  transform: scale(1.05);
}

.dialog-social-media-card .content-container {
  padding: 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #64b4c8 #f0f0f0;
}

.dialog-social-media-text {
  font-size: 1rem;
  font-weight: 500;
  color: #2d3748;
  line-height: 1.5;
  margin: 0;
}

.dialog-social-media-card .stats-container {
  display: flex;
  gap: 16px;
  margin-top: auto;
  padding-top: 12px;
  border-top: 1px solid #edf2f7;
}

.dialog-social-media-card .stat-item {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #64748b;
  font-size: 0.875rem;
}

.dialog-social-media-card .stat-item i {
  color: #64b4c8;
}

.dialog-social-media-card-influencer {
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 16px;
  padding: 20px;
  gap: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  height: 200px;
}

.dialog-social-media-card-influencer:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
}

.tourist-attraction {
  height: 170px !important;
  cursor: default !important;
}

/* Estilização da scrollbar */
.dialog-social-media-card .content-container::-webkit-scrollbar {
  width: 6px;
}

.dialog-social-media-card .content-container::-webkit-scrollbar-track {
  background: #f0f0f0;
  border-radius: 3px;
}

.dialog-social-media-card .content-container::-webkit-scrollbar-thumb {
  background: #64b4c8;
  border-radius: 3px;
}

.dialog-social-media-card .content-container::-webkit-scrollbar-thumb:hover {
  background: #4a8a9e;
}

/* Estilos para os botões e controles */
.button-container {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding: 0 20px 20px;
}

.button-container button {
  padding: 10px 24px;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
  cursor: pointer;
}

.button-container button.cancel {
  background-color: #e2e8f0;
  color: #64748b;
}

.button-container button:not(.cancel) {
  background-color: #64b4c8;
  color: #ffffff;
}

.button-container button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.input-container {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  background: #ffffff;
  padding: 12px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.remove-btn {
  background: none;
  border: none;
  color: #ef4444;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.remove-btn:hover {
  background-color: #fee2e2;
}

/* Estilos para o modal de loading */
.modal-loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-loading-content {
  text-align: center;
}

.modal-loading-text {
  margin-top: 16px;
  color: #2d3748;
  font-weight: 500;
}

.delete-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 2;
}

.delete-btn i {
  color: #ef4444;
  font-size: 14px;
}

.delete-btn:hover {
  background: #fee2e2;
  transform: scale(1.1);
}

@media (max-width: 1200px) {
  .dialog-social-media-container {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 900px) {
  .dialog-social-media-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .dialog-social-media-container {
    grid-template-columns: 1fr;
  }
}
</style>
